// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CardGroup__group___ZoXHK {
    display: flex;
    flex-flow: column nowrap;
    gap: 0.4rem;

    padding: 0.4rem;

    border: 0.1rem solid var(--color-bg-border);
    border-radius: 0.6rem;
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/ToolBar/CardGroup/CardGroup.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,wBAAwB;IACxB,WAAW;;IAEX,eAAe;;IAEf,2CAA2C;IAC3C,qBAAqB;AACzB","sourcesContent":[".group {\n    display: flex;\n    flex-flow: column nowrap;\n    gap: 0.4rem;\n\n    padding: 0.4rem;\n\n    border: 0.1rem solid var(--color-bg-border);\n    border-radius: 0.6rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"group": `CardGroup__group___ZoXHK`
};
export default ___CSS_LOADER_EXPORT___;
